import { ShimmerTwoCol } from "./DashboardShimmer";
import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const DUMMY = {
  evaporation: { pct_in_maturity: "3.2%", assumed_kg: "1,840", assumed_cases: "92" },
};

const ClockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
    <path d="M12 6v6l4 2"/>
  </svg>
);

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
  </svg>
);

const LossMetrics = ({ data = DUMMY, isLoading = false }) => {
  const trashMetrics = [
    { label: "Non-Trash %",       key: "non_trash_prcnt",        color: "green"  },
    { label: "Total Trash %",     key: "total_trash_prcnt",      color: "red"    },
    { label: "Processing Loss %", key: "processing_trash_prcnt", color: "orange" },
    { label: "Sorting Loss %",    key: "sorting_trash_prcnt",    color: "orange" },
  ];

  return (
    <div>
      <div className="internal-section-title">
        <span className="db-title-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
          </svg>
        </span>
        Loss Metrics
      </div>
      {isLoading ? (
        <ShimmerTwoCol />
      ) : (
        <div className="db-two-col">
          <DashboardCard title="Evaporation Metrics" icon={<ClockIcon />}>
            <div className="db-evap-row">
              <div className="db-evap-box">
                <div className="db-evap-label">% In Maturity</div>
                <div className="db-evap-value">{data?.evaporation_metrics?.total_evaporation_prcnt}</div>
              </div>
              <div className="db-evap-box">
                <div className="db-evap-label">Assumed KG</div>
                <div className="db-evap-value neutral">{data?.evaporation_metrics?.total_evaporation_kg}</div>
              </div>
              <div className="db-evap-box">
                <div className="db-evap-label">Assumed Cases</div>
                <div className="db-evap-value neutral">{data?.evaporation_metrics?.assumed_evaporation_cases}</div>
              </div>
            </div>
          </DashboardCard>

          <DashboardCard title="Trash Metrics" icon={<TrashIcon />}>
            <div className="db-trash-grid">
              {trashMetrics.map((metric, i) => {
                const value = data?.trash_metrics?.[metric.key] ?? 0;
                return (
                  <div key={i} className="db-trash-cell">
                    <span>{metric.label}</span>
                    <span className={`db-trash-val ${metric.color}`}>{value}%</span>
                  </div>
                );
              })}
            </div>
          </DashboardCard>
        </div>
      )}
    </div>
  );
};

export default LossMetrics;
